import { WarrantyLogEditInput, WarrantyLogInput, WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

type WarrantyLogProps = {
  id: number;
  requestBody?: WarrantyLogEditInput;
};

export const useWarrantyLogEditMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof WarrantyLogService.putWarrantyLog>>,
      QueryError,
      WarrantyLogProps,
      unknown
    >,
    'mutationFn'
  >
) => useMutation((input: WarrantyLogProps) => WarrantyLogService.putWarrantyLog(input.id, input.requestBody), options);
